import { z } from 'zod'

import ZBaseAction from './base'

const ZRunQuotaAction = ZBaseAction.extend({
  runQuota: z.object({}),
})

export default ZRunQuotaAction
